import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import { Button } from "@/components/ui/button";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  useSeo({ title: "FAQ", description: "Frequently asked questions about working with Buddy Solution." });
  const { data: faqs = [] } = useQuery({ queryKey: ["faqs"], queryFn: async () => (await api.get("/faqs")).data });
  const cats = [...new Set(faqs.map((f) => f.category))];

  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="FAQ" title="Frequently asked questions"
        subtitle="Everything you need to know about working with us. Still have questions? Just reach out." /></Reveal>

      <div className="mx-auto mt-12 max-w-3xl">
        {cats.map((cat) => (
          <div key={cat} className="mb-8">
            <h2 className="mb-3 font-display text-lg font-bold">{cat}</h2>
            <Accordion type="single" collapsible>
              {faqs.filter((f) => f.category === cat).map((f, i) => (
                <AccordionItem key={f.id} value={`${cat}-${i}`} data-testid={`faq-item-${f.id}`}>
                  <AccordionTrigger className="text-left font-display text-base font-semibold">{f.question}</AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
        <div className="mt-10 text-center">
          <Button asChild className="rounded-full"><Link to="/contact">Ask us anything</Link></Button>
        </div>
      </div>
    </div>
  );
}
